document.addEventListener('DOMContentLoaded', function () {
  const yearSelect = document.getElementById("birth-year");
  const monthSelect = document.getElementById("birth-month");
  const daySelect = document.getElementById("birth-day");
  const hiddenInput = document.getElementById("birthday2");
  const noteInput = document.getElementById("customer-note");
  const modalWrapper = document.getElementById('memberModalWrapper');
  const overlay = document.getElementById('MRTOverlay');
  const dismissKey = 'member_modal_dismissed_at';
  const dismissedAt = localStorage.getItem(dismissKey);
  const now = Date.now();

  // 年の選択肢（1900〜今年）
  const currentYear = new Date().getFullYear();
  for (let y = currentYear; y >= 1900; y--) {
    const opt = document.createElement("option");
    opt.value = y;
    opt.textContent = y + "年";
    yearSelect.appendChild(opt);
  }

  // 月の選択肢：1〜12
  for (let m = 1; m <= 12; m++) {
    const opt = document.createElement("option");
    opt.value = String(m).padStart(2, '0');
    opt.textContent = m + "月";
    monthSelect.appendChild(opt);
  }

  // 日の選択肢：1〜31
  for (let d = 1; d <= 31; d++) {
    const opt = document.createElement("option");
    opt.value = String(d).padStart(2, '0');
    opt.textContent = d + "日";
    daySelect.appendChild(opt);
  }

  // モーダル表示管理（12時間以内に閉じてたら非表示）
  if (dismissedAt && now - parseInt(dismissedAt, 10) < 43200000) {
    modalWrapper.style.display = 'none';
    overlay.style.display = 'none';
  } else {
    modalWrapper.style.display = 'block';
    overlay.style.display = 'block';
  }

  // オーバーレイのクリックでもモーダルを閉じる
  overlay.addEventListener('click', closeMemberForm);

  // 登録フォーム submit時の処理
  document.getElementById("register-form").addEventListener("submit", function (e) {
    const y = yearSelect.value;
    const m = monthSelect.value;
    const d = daySelect.value;

    if (!y || !m || !d) {
      alert("生年月日をすべて選択してください。");
      e.preventDefault();
      return;
    }

    const birthday = `${y}-${m}-${d}`;
    hiddenInput.value = birthday;
    noteInput.value = `birthday2: ${birthday}`;
  });

  // フォーム＆オーバーレイをフェードアウトして非表示に
  function closeMemberForm() {
    const form = document.querySelector('.MemberRegistrationTop');
    if (form) form.classList.add('fade-out');
    if (overlay) overlay.classList.add('fade-out');

    // 閉じたタイミングを記録（localStorageに）
    localStorage.setItem('member_modal_dismissed_at', Date.now());

    // アニメーション後に display: none
    setTimeout(() => {
      if (form) form.style.display = 'none';
      if (overlay) overlay.style.display = 'none';
      if (modalWrapper) modalWrapper.style.display = 'none';
    }, 400);
  }
});